import React from 'react'
import PropTypes from 'prop-types'
import './features.css'

const STEPS = [
  { num: '01', title: 'Pre-Qualifying Assessment', desc: 'Kindly complete the pre-qualification assessment to initiate your application process.' },
  { num: '02', title: 'Finalize Application',      desc: 'Simply finalize and submit your application.' },
  { num: '03', title: 'Approval',                  desc: 'Lastly, authorize the debt check.' },
  { num: '04', title: 'Instant Deposit',           desc: 'The funds will be credited to your account within minutes.' },
]

const Features = (props) => {
  return (
    <div className={`features-container1 ${props.rootClassName}`}>
      <div className="features-container2">
        <h1 className="features-text1">How To Apply</h1>
      </div>
      <div className="features-steps">
        {STEPS.map((s) => (
          <div key={s.num} className="features-step">
            <div className="features-step-number">{s.num}</div>
            <h1>{s.title}</h1>
            <span>{s.desc}</span>
          </div>
        ))}
      </div>
    </div>
  )
}

Features.defaultProps = { rootClassName: '' }
Features.propTypes = { rootClassName: PropTypes.string }

export default Features
